/**
 * FINDLYDemoShop – base.js
 *
 * Wird als ceres-base.js gebundelt und nach dem Ceres-Bundle geladen.
 * Registriert alle eigenen Vue-Komponenten global, bevor createApp() aufgerufen wird.
 * Vue, Vuex und der ceresStore sind zu diesem Zeitpunkt bereits global verfügbar.
 */
import FindlyMobileNavigation from "./app/components/FindlyMobileNavigation.vue";

Vue.component("findly-mobile-navigation", FindlyMobileNavigation);

// ── Hamburger → Mobile Nav öffnen ────────────────────────────────────────────
// Kopplung vom Ceres Vuex-Store gelöst – Custom Event steuert die Vue-Komponente.
document.addEventListener("click", function (e) {
    if (e.target.closest("#mobile-navigation-toggler")) {
        document.dispatchEvent(new CustomEvent("findly:openMobileNav"));
    }
});

// ── data-findly-action Handler (Chips, Demo-Login, …) ───────────────────────
// ShopBuilder Code-Widgets: data-findly-action + data-findly-* Attribute.
// Kein Inline-Script in plentyOne nötig.
(function () {
    function setInputValue(input, value) {
        if (!input) return;
        var nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value");
        if (nativeSetter && nativeSetter.set) {
            nativeSetter.set.call(input, value);
        } else {
            input.value = value;
        }
        input.dispatchEvent(new Event("input",  { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function findSearchInput() {
        var vueInput = document.querySelector("findly-input .findly-search-input")
            || document.querySelector(".always-visible-search .findly-search-input");
        if (vueInput) {
            return vueInput;
        }

        var candidates = document.querySelectorAll(
            "#page-header .findly-search-input, #page-header .search-input, " +
            "#page-header input[type=\"search\"], header .cmp-search-box input"
        );
        for (var i = 0; i < candidates.length; i++) {
            if (candidates[i].offsetParent !== null) {
                return candidates[i];
            }
        }

        return candidates.length ? candidates[0] : null;
    }

    function findLoginInputs() {
        var form = document.querySelector(".widget-login form, .login-pwd-reset form, form[id^=\"login-form\"]");
        if (!form) {
            return {
                email:    document.querySelector("[data-testing=\"email-login\"]"),
                password: document.querySelector("[data-testing=\"password-login\"]")
            };
        }
        return {
            email:    form.querySelector("[data-testing=\"email-login\"], input[name=\"email\"]"),
            password: form.querySelector("[data-testing=\"password-login\"], input[name=\"password\"]")
        };
    }

    /** Nach Logout zur Startseite in der aktuellen Sprache (z. B. /en/, /fr/, /es/). */
    function resolveLogoutHomePath(pathname) {
        var loc = pathname || "/";
        var prefixes = ["/en", "/fr", "/es"];
        for (var i = 0; i < prefixes.length; i++) {
            var p = prefixes[i];
            if (loc === p || loc === p + "/" || loc.indexOf(p + "/") === 0) {
                return p + "/";
            }
        }
        return "/";
    }

    function resolveLogoutRedirectUrl(triggerEl) {
        var path = triggerEl ? (triggerEl.getAttribute("data-findly-logout-redirect") || "") : "";
        path = path.trim();
        if (!path) {
            path = resolveLogoutHomePath(window.location.pathname);
        }
        var bust = "logout=" + Date.now();
        if (/^https?:\/\//i.test(path)) {
            return path + (path.indexOf("?") >= 0 ? "&" : "?") + bust;
        }
        if (path.charAt(0) !== "/") {
            path = "/" + path;
        }
        return window.location.origin + path + (path.indexOf("?") >= 0 ? "&" : "?") + bust;
    }

    document.addEventListener("click", function (e) {
        var el = e.target.closest("[data-findly-action]");
        if (!el) return;

        var action = el.getAttribute("data-findly-action");

        if (action === "fill-search") {
            var term  = el.getAttribute("data-findly-query") || "";
            var input = findSearchInput();
            if (input) {
                setInputValue(input, term);
                var header = document.getElementById("page-header");
                if (header) header.scrollIntoView({ behavior: "smooth", block: "start" });
                setTimeout(function () { input.focus(); }, 400);
            }
        }

        if (action === "fill-login") {
            var user = el.getAttribute("data-findly-user") || "";
            var pass = el.getAttribute("data-findly-password") || "";
            var fields = findLoginInputs();
            setInputValue(fields.email, user);
            setInputValue(fields.password, pass);

            var loginWidget = document.querySelector(".widget-login");
            if (loginWidget) {
                loginWidget.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            if (fields.email) {
                setTimeout(function () { fields.email.focus(); }, 400);
            }
        }

        if (action === "logout") {
            el.disabled = true;
            fetch("/rest/account/logout", {
                method:      "POST",
                credentials: "same-origin",
                headers:     {
                    "Content-Type": "application/json",
                    "Accept":       "application/json"
                }
            })
                .then(function (res) {
                    if (!res.ok) {
                        throw new Error("Logout fehlgeschlagen: HTTP " + res.status);
                    }
                    // Kurz warten bis Session serverseitig invalidiert ist
                    return new Promise(function (resolve) {
                        setTimeout(resolve, 400);
                    });
                })
                .then(function () {
                    // Cache-Bust: frischer Request damit Twig isLoggedIn neu rendert
                    window.location.replace(resolveLogoutRedirectUrl(el));
                })
                .catch(function () {
                    el.disabled = false;
                });
        }
    });
})();

// ── Scroll-Anchor via CSS-Klasse ──────────────────────────────────────────────
// Elemente mit data-fhp-anchor="xyz" oder Klasse fhp-anchor--xyz
// erhalten automatisch id="xyz". Damit können ShopBuilder-Rows
// per #hash-Link angesprungen werden, ohne dass plentyOne eine id-Feld braucht.
// Verwendung in ShopBuilder Code-Widget: <div class="fhp-anchor--fhp-interaction"></div>
(function () {
    document.addEventListener("DOMContentLoaded", function () {
        // data-fhp-anchor Variante
        document.querySelectorAll("[data-fhp-anchor]").forEach(function (el) {
            el.id = el.getAttribute("data-fhp-anchor");
        });

        // CSS-Klassen-Variante: fhp-anchor--{id}
        document.querySelectorAll("[class*='fhp-anchor--']").forEach(function (el) {
            el.classList.forEach(function (cls) {
                if (cls.startsWith("fhp-anchor--")) {
                    el.id = cls.replace("fhp-anchor--", "");
                }
            });
        });
    });
})();

// ── Findly Lightbox ───────────────────────────────────────────────────────
// Öffnet ein modales Overlay beim Klick auf .findly-cat-img.
// Das Overlay-HTML wird dynamisch erzeugt – kein extra Widget in PlentyOne nötig.
(function () {
    // Overlay einmalig in den Body injizieren
    function createOverlay() {
        if (document.getElementById("findly-lb-overlay")) return;

        const overlay = document.createElement("div");
        overlay.id = "findly-lb-overlay";
        overlay.innerHTML =
            '<a class="findly-cat-lightbox__backdrop" role="button" aria-label="Schließen"></a>' +
            '<a class="findly-cat-lightbox__close" role="button" aria-label="Schließen">&#10005;</a>' +
            '<img src="" alt="">';

        // Schließen bei Klick auf Backdrop oder X
        overlay.addEventListener("click", function (e) {
            if (
                e.target.classList.contains("findly-cat-lightbox__backdrop") ||
                e.target.classList.contains("findly-cat-lightbox__close")
            ) {
                closeOverlay();
            }
        });

        document.body.appendChild(overlay);
    }

    function openOverlay(src, alt) {
        createOverlay();
        const overlay = document.getElementById("findly-lb-overlay");
        const img     = overlay.querySelector("img");
        img.src = src;
        img.alt = alt || "";
        overlay.classList.add("is-open");
        document.body.style.overflow = "hidden";
    }

    function closeOverlay() {
        const overlay = document.getElementById("findly-lb-overlay");
        if (overlay) {
            overlay.classList.remove("is-open");
            document.body.style.overflow = "";
        }
    }

    // ESC-Taste schließt Overlay
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeOverlay();
    });

    // Event-Delegation: Klick auf .findly-cat-img oder .fhp-lightbox
    document.addEventListener("click", function (e) {
        const trigger = e.target.closest(".findly-cat-img, .fhp-lightbox");
        if (!trigger) return;
        e.preventDefault();
        const img = trigger.tagName === "IMG" ? trigger : trigger.querySelector("img");
        if (img) openOverlay(img.src, img.alt);
    });
})();
